import React from 'react';
import { Link } from 'react-router-dom';
import { districts } from '../config/districts';
import { getDistrictSeoName, topSeoDistricts } from '../config/districtSeo';

const DistrictLinks = () => {
  const orderedDistricts = [
    ...topSeoDistricts,
    ...Object.keys(districts).filter((district) => !topSeoDistricts.includes(district))
  ];

  return (
    <div className="bg-white py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-primary mb-8">
          İstanbul'un Tüm İlçelerinde Kepenk Servisi
        </h2>
        <p className="mx-auto mb-8 max-w-3xl text-center text-gray-600">
          Her ilçe sayfası; mahalle kapsaması, sık arıza senaryoları ve yerel servis bilgileriyle ayrı hazırlanmıştır.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {orderedDistricts.map((district) => (
            <Link
              key={district}
              to={`/${district}`}
              className="bg-gray-50 hover:bg-primary hover:text-white p-4 rounded-lg text-center transition-colors"
            >
              {getDistrictSeoName(district)}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DistrictLinks; 
